var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.42829 6.78943C6.3496 4.67259 9.63124 3.27703 11.2732 2.60277C15.9614 0.677612 16.9356 0.343192 17.5705 0.332149C17.7102 0.32972 18.0224 0.363889 18.2247 0.525921C18.3954 0.662738 18.4424 0.847558 18.4649 0.977275C18.4874 1.10699 18.5154 1.40249 18.4932 1.63339C18.2391 4.26878 17.1398 10.6642 16.5806 13.6159C16.3439 14.8648 15.878 15.2836 15.4269 15.3246C14.4465 15.4137 13.7021 14.685 12.7526 14.0705C11.2668 13.1089 10.4274 12.5103 8.98519 11.572C7.31846 10.4877 8.39893 9.89166 9.3488 8.91765C9.59738 8.66274 13.9168 4.78391 14.0004 4.43204C14.0108 4.38804 14.0206 4.224 13.9218 4.13738C13.8231 4.05076 13.6774 4.08038 13.5723 4.10394C13.4233 4.13733 11.0497 5.68621 6.45159 8.75057C5.77786 9.20732 5.16762 9.42986 4.62086 9.4182C4.0181 9.40534 2.85864 9.08173 1.9967 8.80511C0.93949 8.46583 0.0992435 8.28645 0.17241 7.71024C0.21052 7.41012 0.629146 7.10318 1.42829 6.78943Z",
    fill: "#18191B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.5ed9cd56603f84a32b8ae8e29da6f0a2.svg";
export { ForwardRef as ReactComponent };